export default __webpack_public_path__ + "static/media/delete-forever-white.7ace9331.svg";